module.exports = __webpack_public_path__ + "img/Ashley.f88bdfb6.jpg";